import { jsonldAuthorUrl } from './JsonldStore';

export const updateJsonldAuthorUrl = (value) => jsonldAuthorUrl.update((oldValue) => value);
